import { createApp } from 'vue'
import App from './App.vue'
import axios from 'axios'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import store from './store/store'

const app = createApp(App)
app.use(router).use(ElementPlus).use(store).mount('#app')
axios.defaults.baseURL = 'http://39.106.46.114:8081/'
// axios.defaults.baseURL = 'http://localhost:5000/'
// 更新时间

app.config.globalProperties.$colorMap = {
  Human: 'rgb(62,193,211)',
  Humanb: 'rgba(62,193,211,.3)',
  Mouse: 'rgb(255,22,93)',
  Mouseb: 'rgb(255,22,93,.3)',
  Cattle: 'rgb(255,154,0)',
  Cattleb: 'rgb(255,154,0,.3)',
  MAIT: 'rgb(241,91,181)',
  iNKT: 'rgb(0,187,249)',
  GEMT: 'rgb(14,170,128)',
  'γδ T cell': 'rgb(243,164,59)',
  CD8αα: 'rgb(0,116,228)',
  CAIT: 'rgba(127, 223, 44)',
  'MAIT-like':'rgba(214,24,14)',
  MAITb: 'rgb(241,91,181,.3)',
  iNKTb: 'rgb(0,187,249,.3)',
  GEMTb: 'rgb(0,245,212,.3)',
  'γδ T cellb': 'rgb(243,164,59,.3)',
  CD8ααb: 'rgb(0,116,228, .3)',
  CAITb: 'rgba(127, 223, 44, .3)',
'MAIT-likeb':'rgba(214,24,14, .3)',

  TRA: 'rgb(202,130,248)',
  TRB: 'rgb(161,222,147)',
  TRG: 'rgb(112,161,215)',
  TRD: 'rgb(244,124,124)',
  TRAb: 'rgb(202,130,248,.3)',
  TRBb: 'rgb(161,222,147,.3)',
  TRGb: 'rgb(112,161,215,.3)',
  TRDb: 'rgb(244,124,124,.3)',
  Paired:'#bc64a4',
}